import React, { useState, Component } from 'react';
import { Tag, Check, Clock, Package } from 'lucide-react';
import { offers, Offer } from '../data/offers';
import { WA_NUMBER } from '../data/products';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
import { OfferModal } from './OfferModal';
export function OffersSection() {
  const [selectedOffer, setSelectedOffer] = useState<Offer | null>(null);
  return <section className="bg-dark-900 py-[80px] px-5 relative" id="ofertas" data-id="element-341" data-mp="b4di97t9wzrv">
      {/* Top accent line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#ff3b30] to-transparent" data-id="element-342" data-mp="6628sy6w4ra6" />

      <div className="max-w-[1100px] mx-auto" data-id="element-343" data-mp="jxyw8oxm6d08">
        <div className="inline-flex items-center gap-2 bg-[#ff3b30]/10 border border-[#ff3b30]/40 text-[#ff3b30] px-4 py-1.5 rounded-full text-xs md:text-sm font-bold uppercase tracking-[2px] mb-4 mx-auto block w-fit" data-id="element-344" data-mp="jyrzhfxd6kdm">
          <Tag className="w-4 h-4 inline" data-id="element-345" data-mp="3jkor4875c5bk" /> Precios de Liquidación
        </div>

        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white flex items-center justify-center gap-3" data-id="element-346" data-mp="3jim2nsln6k8y">
          <Tag className="w-8 h-8 text-[#ff3b30]" data-id="element-347" data-mp="xm74qq0kfn5o" /> OFERTAS IMPERDIBLES
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-348" data-mp="12dp4xburljpl">
          Hacé click en cualquier oferta para ver todos los detalles y hacer tu
          pedido
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[24px]" data-id="element-349" data-mp="9pjkyrbjbyqt">
          {offers.map(offer => {
          const discount = Math.round((offer.originalPrice - offer.offerPrice) / offer.originalPrice * 100);
          const isCombo = offer.includes.length > 0;
          return <div key={offer.id} onClick={() => setSelectedOffer(offer)} className="bg-dark-800 border-2 border-[#ff3b30]/40 rounded-xl overflow-hidden transition-all duration-300 hover:border-[#ff3b30] hover:-translate-y-2 hover:shadow-[0_10px_30px_rgba(255,59,48,0.25)] flex flex-col relative cursor-pointer group" data-id="element-350" data-mp="onvguvr333gx">
                {/* Discount badge */}
                <div className="absolute top-3 right-3 bg-[#ff3b30] text-white text-sm font-black w-12 h-12 rounded-full flex items-center justify-center z-10 shadow-lg rotate-6" data-id="element-351" data-mp="3r8550q5tmktl">
                  -{discount}%
                </div>

                <div className="relative bg-white h-52 flex items-center justify-center p-1 overflow-hidden" data-id="element-352" data-mp="3ddulcn8olgue">
                  <div className="absolute top-3 left-3 bg-[#ff3b30] text-white text-[0.7rem] font-black px-2.5 py-1 rounded-full uppercase tracking-wider z-10 shadow-md flex items-center gap-1" data-id="element-353" data-mp="38gcdl06eh7nz">
                    {isCombo ? <>
                        <Tag className="w-3 h-3" data-id="element-354" data-mp="2tqdhr42bi8bo" /> Combo
                      </> : <>
                        <Package className="w-3 h-3" data-id="element-355" data-mp="2ppl7c7hplxdt" /> Oferta
                      </>}
                  </div>
                  <img src={offer.image} alt={offer.name} className={`max-w-full max-h-full object-contain transition-transform duration-300 ${offer.imageZoom ? 'scale-[1.32] group-hover:scale-[1.4]' : 'scale-110 group-hover:scale-[1.18]'}`} data-id="element-356" data-mp="2fja9o8o994a5" />
                </div>

                <div className="p-5 flex flex-col flex-grow" data-id="element-357" data-mp="33afkg9fc96dl">
                  <h3 className="text-base font-black text-white mb-3 uppercase tracking-wide leading-tight min-h-[2.5rem]" data-id="element-358" data-mp="339xjx0ln85zv">
                    {offer.name}
                  </h3>

                  {isCombo && <ul className="space-y-1.5 mb-4" data-id="element-359" data-mp="2tecjh6w83ds8">
                      {offer.includes.map((item, idx) => <li key={idx} className="flex items-start gap-1.5 text-[#ccc] text-xs font-medium" data-id="element-360" data-mp="1hx32cr0kgxu3" data-mpi={idx}>
                          <Check className="w-3.5 h-3.5 text-[#ff3b30] shrink-0 mt-0.5" data-id="element-361" data-mp="1y6bvuy3oedfq" />
                          <span data-id="element-362" data-mp="1tbfuh7cjudpy">{item}</span>
                        </li>)}
                    </ul>}

                  <div className="mt-auto pt-4 border-t border-dark-500 mb-4" data-id="element-363" data-mp="1jfuybpu5w7o4">
                    <div className="flex items-end gap-2 mb-2 flex-wrap" data-id="element-364" data-mp="2h33dl33kkkho">
                      <span className="text-2xl font-black text-[#ff3b30]" data-id="element-365" data-mp="2h2brqjzry14l">
                        ${offer.offerPrice.toLocaleString('es-UY')}
                      </span>
                      <span className="text-sm text-[#666] line-through font-bold mb-0.5" data-id="element-366" data-mp="273ma8sbsiiov">
                        ${offer.originalPrice.toLocaleString('es-UY')}
                      </span>
                    </div>
                    <div className="inline-block bg-[#ff3b30]/15 border border-[#ff3b30]/40 text-[#ff7a73] text-[0.7rem] font-bold px-2 py-0.5 rounded" data-id="element-367" data-mp="vr1z9ki8tjpa">
                      AHORRÁS ${offer.savings.toLocaleString('es-UY')}
                    </div>
                  </div>

                  <a href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(offer.waMessage)}`} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} className="w-full bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold py-3 px-3 rounded-lg flex items-center justify-center gap-2 transition-colors duration-300 mb-3 text-sm" data-id="element-368" data-mp="37e5fyqr5a4eg">
                    <WhatsAppIcon className="w-4 h-4" data-id="element-369" data-mp="3v26m5t0up8qp" />
                    LO QUIERO
                  </a>

                  <div className="flex items-center justify-center gap-1.5 text-[#ff3b30] text-[0.7rem] font-bold uppercase tracking-wider" data-id="element-370" data-mp="3wna2ouxn7go">
                    <Clock className="w-3 h-3" data-id="element-371" data-mp="20qi0l80467xc" />
                    Stock limitado
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>

      <OfferModal offer={selectedOffer} onClose={() => setSelectedOffer(null)} data-id="element-372" data-mp="1xnca96oz81ei" />
    </section>;
}